const ApplyMode = {
    PREQUALIFY: "prequalify",
    PRESCREEN: "prescreen",
    FULL: "full"
}


export const getMessagesApplyMode = function(applyMode) {
    if (applyMode === ApplyMode.PRESCREEN) return ApplyMode.PREQUALIFY
    return applyMode
}

export default ApplyMode
